module.exports = __webpack_public_path__ + "a7a55fdaec36d28c32e2af1c27cbc376.png";